import React from "react";
import { connect } from "react-redux";
import { Modal, Button, FormControl } from "react-bootstrap";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { notification } from 'antd'

import { setUnit, setUnits } from "../actions";
import { setLoading } from "@inspinia-react/actions";
import { saveUnit, getUnits } from "../../utils";

const STYLE = { cursor: "pointer" };

import { mapTest } from '../../map.test'

class ModalCreateUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      trigger: <i></i>,
      name: "",
      key: "",
      title: "",
    };
    this._triggerAction = this._triggerAction.bind(this);
    this._setInputName = this._setInputName.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._handleOk = this._handleOk.bind(this);
    this._handleEnter = this._handleEnter.bind(this);
  }

  _iconTrigger() {
    const title = `Criar uma nova ${this.state.title}`;
    const trigger = (
      <i
        style={STYLE}
        onClick={this._triggerAction}
        title={title}
        className="fas fa-plus ml-2 text-primary"
      ></i>
    );

    this.setState({ ...this, trigger });
  }

  _buttonTrigger() {
    const title = `Criar uma nova ${this.state.title}`;
    const trigger = <Button onClick={this._triggerAction}>{title}</Button>;
    this.setState({ ...this, trigger });
  }
  _setUnitToProps(unit) {
    unit["label"] = unit.name;
    unit["value"] = unit.id;
    this.props.setUnit(unit);
  }
  _checkNameOnUnits() {
    this.props.setLoading(true);
    const { units } = this.props;
    const { name } = this.state;

    for (let x = 0; x < units.length; x++) {
      const unit = units[x];
      if (name.toLowerCase() === unit.name.toLowerCase()) {
        this._setUnitToProps(unit);
        this.props.setLoading(false);
        this._closeModal();
        notification.open({
          type: 'info',
          message: "Unidade já cadastrada",
          key: "4311"
        })
        return;
      }
    }
    const payload = (unit) => {
      this._setUnitToProps(unit);
      this._closeModal();
      const p = (units) => {
        this.props.setLoading(false);
        this.props.setUnits(units);
      };
      getUnits(p);
    };
    saveUnit(name, payload);
  }

  _triggerAction() {
    this.setState({ ...this, show: true });
  }

  _handleEnter(e) {
    if (e.key === "Enter") {
      this._checkNameOnUnits();
    }
  }

  _closeModal() {
    this._setInputName({ target: { value: "" } });
    this.setState({ ...this, show: false });
  }
  _handleOk() {
    const { name } = this.state;
  }

  _setInputName(e) {
    let name = e.target.value;
    this.setState({ ...this, name });
  }

  UNSAFE_componentWillMount() {
    const { trigger, key, name } = this.props;
    this.setState({ ...this, title: name ? name : "Unidade" });

    switch (trigger) {
      case "button":
        this._buttonTrigger()
        break;
      default:
        this._iconTrigger();
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.trigger}
        <Modal show={this.state.show}>
          <Modal.Header>
            <h2>Criar Unidade</h2>
          </Modal.Header>
          <Modal.Body>
            <label htmlFor="input-unit-name">Nome *</label>
            <FormControl
              disabled={this.state.loading}
              maxLength="20"
              onKeyPress={this._handleEnter}
              value={this.state.name}
              placeholder={`Insira aqui o nome da unidade.`}
              onChange={this._setInputName}
              id={mapTest.createProduct.unit.inputName}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={this.state.loading}
              onClick={this._closeModal}
              className="py-2 mr-auto"
              variant="outline-danger"
              size="sm"
              id={mapTest.createProduct.unit.buttonClose}
            >
              Fechar
            </Button>
            <Button
              disabled={this.state.loading}
              onClick={this._handleOk}
              className="py-2"
              variant="outline-primary"
              size="sm"
              id={mapTest.createProduct.unit.buttonSave}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}
ModalCreateUnit.propTypes = {
  trigger: PropTypes.oneOf(["icon", "button"]),
};

const mapStateToProps = (state) => ({
  units: state.units,
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setUnit, setUnits, setLoading }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateUnit);



// WEBPACK FOOTER //
// ./src/components/pages/products/base/unit/modal-create-unit.jsx